import { GameConfigs } from '../GameConfigs';
import { EVENTS } from '../../../lib/constants';
import { Texture, AnimatedSprite } from 'pixi.js';
import { formatValue } from '../../../controllers/helper/currencies';
import { logger } from '@orbital/slot-lib';

class HELPERS {
	static setSettings(obj) {
		if (obj.background_music !== undefined) {
			GameConfigs.settings.background_music = obj.background_music;
		}
		if (obj.sound_effects !== undefined) {
			GameConfigs.settings.sound_effects = obj.sound_effects;
		}
		if (obj.fast_spin !== undefined) {
			GameConfigs.settings.fast_spin = obj.fast_spin;
		}
		if (obj.game_animation !== undefined) {
			GameConfigs.settings.game_animation = obj.game_animation;
		}
		if (obj.splash_screen !== undefined) {
			GameConfigs.settings.splash_screen = obj.splash_screen;
		}
		if (obj.keyboard_shortcuts !== undefined) {
			GameConfigs.settings.keyboard_shortcuts = obj.keyboard_shortcuts;
		}
		if (obj.current_bet !== undefined) {
			GameConfigs.settings.current_bet = obj.current_bet;
		}
		if (obj.current_bet === undefined) {
			GameConfigs.settings.current_bet = GameConfigs.config.bet_steps.indexOf(
				GameConfigs.currentBet
			);
		}
		HELPERS.sendSettings(obj);
	}
	static sendSettings(obj) {
		window.connectionProvider.sendSettings(
			JSON.stringify({
				service: 'settings',
				data: GameConfigs.settings
			})
		);
		HELPERS.dispatchCustomEvent(EVENTS.SETTINGS_UPDATE, {
			data: obj
		});
	}
	static disableAllButtons(bool) {
		let disabled = {
			bonus_widget: bool,
			double_widget: bool,
			info: bool,
			settings: bool,
			spin: bool,
			auto: bool,
			fast: bool,
			quest_widget: bool,
			bet_amount: bool
		};
		HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
		GameConfigs.disabled = disabled;
	}

	static setCurrentMessage(msg) {
		if (msg.reels) {
			GameConfigs.betReels = msg.reels;
		}
		if (msg.winlines) {
			GameConfigs.win = 0;
			for (let index = 0; index < msg.winlines.length; index++) {
				GameConfigs.win =
					GameConfigs.win + parseFloat(msg.winlines[index].amount);
			}
		}
		logger.log(
			`%cWIN: ${GameConfigs.win}`,
			'color: red; background: black; padding: 10px'
		);
	}

	static setBonusRestoreMsg(msg) {
		GameConfigs.bonusRestore = msg;
	}

	static formatBalance(val) {
		let value = formatValue(val);
		return value;
	}

	static getWinLevels() {
		// let coeff = 25;
		let coeff = GameConfigs.win / GameConfigs.currentBet;
		let res = [];
		// coeff = 35
		//"W": 11, "S": 10, "A": 9, "R": 8, "M": 7, "H": 6, "T": 5, "C": 4, "K": 3, "Q": 2, "J": 1, "1": 0,
		if (coeff >= 20 && coeff < 30) {
			res.push({ name: 'nicewin', min: 0, max: 100, time: 3500 });
		}
		if (coeff >= 30 && coeff < 50) {
			res.push({ name: 'nicewin', min: 0, max: 50, time: 2000 });
			res.push({ name: 'superwin', min: 50, max: 100, time: 6000 });
		}
		if (coeff >= 50 && coeff < 100) {
			res.push({ name: 'nicewin', min: 0, max: 40, time: 2000 });
			res.push({ name: 'superwin', min: 40, max: 70, time: 2000 });
			res.push({ name: 'megawin', min: 70, max: 100, time: 9000 });
		}
		if (coeff >= 100) {
			res.push({ name: 'nicewin', min: 0, max: 40, time: 2000 });
			res.push({ name: 'superwin', min: 40, max: 60, time: 3000 });
			res.push({ name: 'megawin', min: 60, max: 80, time: 4000 });
			res.push({ name: 'maxwin', min: 80, max: 100, time: 9000 });
		}
		// res = [{ name: 'nicewin', min: 0, max: 100, time: 3500 }]
		return res;
	}
	static getAnimatedSprite(obj) {
		const textureArray = [];

		var patternParts = obj.pattern.split('$');
		for (let i = obj.start; i <= obj.end; i += 1) {
			let current =
				patternParts[0] + String(i).padStart(2, '0') + patternParts[1];
			const texture = Texture.from(current);
			textureArray.push(texture);
		}
		let anim = new AnimatedSprite(textureArray);
		anim.loop = obj.loop;
		anim.animationSpeed = obj.speed;
		return anim;
	}
	static dispatchCustomEvent(eventName, eventObj) {
		if (eventName === EVENTS.MODAL) {
			GameConfigs.modal = eventObj;
		}
		window.dispatchEvent(
			new CustomEvent(eventName, {
				detail: eventObj
			})
		);
	}

	static handleOutsideClick(
		target,
		clickedX,
		clickedY,
		modal,
		interaction,
		vc
	) {
		const currentX = clickedX;
		const currentY = clickedY;
		if (!interaction) return;
		if (modal === GameConfigs.modal) {
			if (
				currentY < target.y ||
				currentX < target.x ||
				currentX > target.x + target.width ||
				currentY > target.y + target.height
			) {
				// console.log('clicked outside', 'e.y:', currentY, 'currentY:', currentY, 'e.x:', currentX, 'currentX:', currentX, 'sizes:', target)
				// setTimeout(() => {
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
				// }, 100);
				return true;
			} else {
				// console.log('clicked inside', 'e.y:', currentY, 'currentY:', currentY, 'e.x:', currentX, 'currentX:', currentX, 'sizes:', target)
			}
		}
	}

	static printReels(reels) {
		const symbols = [
			'🔟 TEN',
			'🃏 JACK',
			'👑 QUEEN',
			'🤴 KING',
			'🂡 ACE',
			'🔭 TELESCOPE',
			'🪖 HELMET',
			'☄️ ASTEROID',
			'🚀 STARSHIP',
			'👽 ALIEN',
			'⭐ SCATTER',
			'💎 WILD',
			'💎 DIAMOND'
		];
		let logOutput = '%c🎰 RECEIVED REELS 🎰\n';
		logOutput += '%c========================\n';

		reels.forEach((reel, index) => {
			const symbolsReel = reel.map((value) => symbols[value]);
			logOutput += `%c🎞️ Reel ${index + 1}: %c${symbolsReel.join(' | ')}\n`;
		});

		logOutput += '%c========================\n';
		console.log(
			logOutput,
			'background: #333; color: gold; font-size: 16px; font-weight: bold; padding: 4px;', // Title style
			'background: #333; color: gold; padding: 4px;', // Separator style
			...reels.flatMap(() => [
				'background: #333; color: lightblue; padding: 4px;',
				'background: #333; color: white; padding: 4px;'
			]), // Reel styles
			'background: #333; color: gold; padding: 4px;' // Separator style
		);
	}
}

export default HELPERS;
